import { styled } from '@mui/material';

export const ShowMore = styled('div')`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
`;

export const MoreLink = styled('span')`
  color: ${({ theme }) => theme.palette.info.main};
  font-size: 14px;
  font-weight: 400;
  text-decoration: underline;
  line-height: 20px;
`;

export const ShowLess = styled('div')`
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: ${({ theme }) => theme.palette.info.main};
`;

export const EquipmentAttachmentContainer = styled('div')<{ showMore: boolean }>`
  display: flex;
  gap: 8px;
  flex-direction: ${({ showMore }) => (showMore ? 'column' : 'row')};

  @media (max-width: 1023px) {
    flex-direction: column;
  },
`;
